export default "__VITE_ASSET__ChLjuIaY__"